import { action, makeAutoObservable } from "mobx";
import env from "../../config/env";
import http from "../../services/http";
import { AxiosInstance } from "axios";
import { ServiceResult } from "../../types/general-types";
import { VerifyECaptchaRequestDto, GetECaptchaResponseDto } from "./types";

const { API_BASE_URL } = env;
class Store {
  static readonly id: string = "ECaptchaStore";
  readonly baseURL: string = "e-captcha";

  get api(): AxiosInstance {
    http.defaults.baseURL = API_BASE_URL;
    return http;
  }
  constructor() {
    makeAutoObservable(this);

    this.GetECaptcha = this.GetECaptcha.bind(this);
  }

  @action.bound async GetECaptcha(length: number) {
    const response: ServiceResult<GetECaptchaResponseDto> = await (
      await this.api.get(
        `/${this.baseURL}/get?length=${btoa(length.toString())}`
      )
    ).data;
    return response;
  }
}

export default Store;
